// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CAR_DATA_MASTER_UPDATE_CAR_DEALERSHIP_LIST,
} from './constants';

export function updateCarDealershipList(text) {
  return {
    type: CAR_DATA_MASTER_UPDATE_CAR_DEALERSHIP_LIST,
    text: text
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_UPDATE_CAR_DEALERSHIP_LIST:
      let aux = [...state.carDealershipListOrigin];
      aux = aux.filter(carDealership => carDealership.code.toLowerCase().includes(action.text.toLowerCase()) || carDealership.businessName.toLowerCase().includes(action.text.toLowerCase()) || carDealership.cuit.toLowerCase().includes(action.text.toLowerCase()));
      return {
        ...state,
        carDealershipList: [...aux]
      };

    default:
      return state;
  }
}
